import { useLocalObservable } from 'mobx-react-lite';
import StoreAction from '@store/StoreAction';
import { runInAction } from 'mobx';
import { callGetCustomerInfo } from '@api';

const initialState = {
    account: '',
    borrowingAmount: 0,
    borrowedAmount: 0,
    debitDeliveryBankAccount: '',
    name: '',
    maintenanceRatio: 0,
    financingLimit: 0,
    open: true,
    creditFacilities: 0,
    bhno: '',
    interestRate: 0,
    contractExpiryDate: '',
    deadLine: '',
    queryTime: '',
    transFlag: '1',
    realSync: false,
    idno: '',
    nextRealSyncTime: '',
};

const api = {
    // uploadPhoto: callUploadPhoto,
    getInfo: callGetCustomerInfo,
};
const AuthStore = () =>
    useLocalObservable(() => ({
        /* observables */
        ...initialState,
        ...api,
        ...StoreAction(initialState),
        async updateUserInfo() {
            const token = localStorage.getItem('token');
            const res = await this.getInfo({
                token,
            }); // TODO Make this dynamically
            const code = parseInt(res.data.code);
            const userInfo = res.data.item;
            this.assignData({ ...userInfo });
            if (res.status === 200 && !code) {
                return [
                    this.borrowedAmount,
                    this.transFlag,
                    this.realSync,
                    this.nextRealSyncTime,
                ];
            }
        },
        async getIdno() {
            const token = localStorage.getItem('token');
            const res = await this.getInfo({
                token,
            }); // TODO Make this dynamically
            const code = parseInt(res.data.code);
            const userInfo = res.data.item;
            return userInfo.idno;
        },
    })); // 3

export default AuthStore; // 2
